import React, { useState } from 'react';
import axios from 'axios';
import LoadingPopup from '../../SharedView/LoadingPopup';
import './editItem.css';

function AddItem({ isOpen, onClose, onSave }) {
  const [formData, setFormData] = useState({
    name: '', default_price: '', is_addon: false, is_laundry: false,
    is_client_addon: false, client_display_name: '',
    create_zoho_item: false, zoho_display_name: '', existing_zoho_item_id: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  // The client display name pre-fills from the item name and keeps mirroring it
  // until the user edits it directly (2026-07-20).
  const [clientNameTouched, setClientNameTouched] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'client_display_name') setClientNameTouched(true);
    setFormData(prev => {
      const next = { ...prev, [name]: type === 'checkbox' ? checked : value };
      if (name === 'name' && !clientNameTouched) next.client_display_name = value;
      return next;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const payload = {
        name: formData.name,
        default_price: parseFloat(formData.default_price),
        is_addon: formData.is_addon,
        is_laundry: formData.is_laundry,
        is_client_addon: formData.is_client_addon,
        client_display_name: formData.client_display_name || null,
        create_zoho_item: formData.create_zoho_item,
        zoho_display_name: formData.create_zoho_item ? formData.zoho_display_name : null,
        zoho_item_id: formData.create_zoho_item ? null : formData.existing_zoho_item_id || null,
      };
      const response = await axios.post('/api/items', payload);
      if (response.status === 201) {
        onSave(response.data.item);
        setIsLoading(false);
        setFeedbackMessage('Item added successfully.');
        setIsSuccess(true);
      }
    } catch (err) {
      console.error('Error adding item:', err);
      setIsLoading(false);
      setFeedbackMessage(err.response?.data?.message || 'Failed to add item.');
    }
  };

  const handlePopupClose = () => {
    setFeedbackMessage('');
    if (isSuccess) { setIsSuccess(false); onClose(); }
  };

  if (!isOpen) return null;

  return (
    <div className="itemModal__overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="itemModal">
        <button type="button" className="modal-x" onClick={onClose}>&times;</button>
        <h2 className="itemModal__title">Add New Item</h2>

        <form onSubmit={handleSubmit} className="itemModal__form">
          <div className="itemModal__group">
            <label className="itemModal__label">Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className="itemModal__input" required />
          </div>

          <div className="itemModal__group">
            <label className="itemModal__label">Default Price (AED)</label>
            <input type="number" name="default_price" value={formData.default_price} onChange={handleChange} step="0.01" className="itemModal__input" required />
          </div>

          <div className="itemModal__toggles">
            <label className="itemModal__toggle">
              <input type="checkbox" name="is_addon" checked={formData.is_addon} onChange={handleChange} />
              <span>Add-on</span>
            </label>
            <label className="itemModal__toggle">
              <input type="checkbox" name="is_laundry" checked={formData.is_laundry} onChange={handleChange} />
              <span>Laundry</span>
            </label>
            <label className="itemModal__toggle">
              <input type="checkbox" name="is_client_addon" checked={formData.is_client_addon} onChange={handleChange} />
              <span>Extra linen (client-selectable)</span>
            </label>
          </div>

          {formData.is_client_addon && (
            <div className="itemModal__group">
              <label className="itemModal__label">Client display name</label>
              <input
                type="text"
                name="client_display_name"
                value={formData.client_display_name}
                onChange={handleChange}
                className="itemModal__input"
                placeholder="Name shown to clients"
              />
              <span className="itemModal__hint">Shown to clients when they add this. Pre-filled from the item name — edit if you want something different.</span>
            </div>
          )}

          <div className="itemModal__zohoToggle">
            <label className="itemModal__toggle itemModal__toggle--zoho">
              <input type="checkbox" name="create_zoho_item" checked={formData.create_zoho_item} onChange={handleChange} />
              <span>Create in Zoho Books</span>
            </label>
          </div>

          {formData.create_zoho_item ? (
            <div className="itemModal__group">
              <label className="itemModal__label">Zoho Display Name</label>
              <input type="text" name="zoho_display_name" value={formData.zoho_display_name} onChange={handleChange} className="itemModal__input" required />
            </div>
          ) : (
            <div className="itemModal__group">
              <label className="itemModal__label">Existing Zoho Item ID (optional)</label>
              <input type="text" name="existing_zoho_item_id" value={formData.existing_zoho_item_id} onChange={handleChange} className="itemModal__input" />
            </div>
          )}

          <div className="itemModal__actions">
            <button type="button" onClick={onClose} className="itemModal__btn itemModal__btn--ghost">Cancel</button>
            <button type="submit" className="itemModal__btn itemModal__btn--primary" disabled={isLoading}>
              {isLoading ? 'Adding...' : 'Add Item'}
            </button>
          </div>
        </form>
      </div>
      <LoadingPopup isLoading={isLoading} feedbackMessage={feedbackMessage} onClose={handlePopupClose} />
    </div>
  );
}

export default AddItem;
